import '@/scss/my-courses.css'


Array.from(document.querySelectorAll('a[id^="download-course-results-"]')).forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    const el = e.target;
    const orderId = el.id.split('-')[3];
    const nonce = el.parentElement.querySelector('input[name="nonce"]').value;

    // fill the form data
    const data = new FormData();
    data.append('action', 'rtmae_result_form_download');
    data.append('nonce', nonce);
    data.append('order_id', orderId);

    // change the text of the button
    const currentText = el.innerText;
    el.innerHTML = '<i class="fa fa-spinner fa-pulse"></i>';

    // send the request
    fetch(wp.ajax.url, {
      method: 'POST',
      body: data,
    }).then((response) => {
      // if the response is ok, return a blob, otherwise return the json
      return response.ok ? response.blob() : response.json();
    }).then((r) => {
      if (r instanceof Blob) {
        // generate a temp <a /> tag
        const a = document.createElement('a');
        a.style.display = 'none';
        document.body.appendChild(a);

        // create a blobURI pointing to our Blob
        const blob = new Blob([r]);
        const blobURI = window.URL.createObjectURL(blob);
        a.href = blobURI;

        // set the name of the file
        a.download = `taalthuis-course-results-${orderId}.pdf`;

        // click the link
        a.click();

        // remove the temp <a /> tag
        a.parentNode.removeChild(a);
      } else {
        console.error(r);
      }
    })
      .finally(() => {
        el.innerText = currentText;
      });
  });
});

var closeButtons = [...document.querySelectorAll(".cancel-order-modal .close"), ...document.querySelectorAll(".cancel-order-modal .decline")];

Array.from(document.querySelectorAll('.cancel-button')).forEach((el) => {
  const orderId = el.getAttribute('data-order-id');
  el.addEventListener('click', (e) => {
    el.style.display = "block";
    document.getElementById(`cancel-order-modal-${orderId}`).style.display = "block";
  });
});

Array.from(closeButtons).forEach((close) => {
  const orderId = close.getAttribute('data-order-id');
  close.onclick = function() {
    document.getElementById(`cancel-order-modal-${orderId}`).style.display = "none";
  }
});

// When the user clicks anywhere outside the modal, close it
window.onclick = function(event) {
  const orderId = event.target.getAttribute('data-order-id');
  if (orderId) {
    const modal = document.getElementById(`cancel-order-modal-${orderId}`);

    if (modal && event.target == modal) {
      modal.style.display = "none";
    }
  }
}

// Cancel order
Array.from(document.querySelectorAll('.cancel-button-modal.accept')).forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    const orderId = el.getAttribute('data-order-id');
    const courseId = el.getAttribute('data-course-id');
    const nonce = el.parentElement.querySelector('input[name="nonce"]').value;

    // fill the form data
    const data = new FormData();
    data.append('action', 'taalthuis_cancel_order');
    data.append('nonce', nonce);
    data.append('order_id', orderId);
    data.append('course_id', courseId);

    // change the text of the button
    const currentText = el.innerText;
    el.innerHTML = '<i class="fa fa-spinner fa-pulse"></i>';

    // send the request
    fetch(wp.ajax.url, {
      method: 'POST',
      body: data,
    }).then((response) => {
      return response.json();
    }).then((r) => {
      if (r.success) {
        document.getElementById(`cancel-order-modal-${orderId}`).style.display = "none";
        window.location.reload();
      } else {
        alert(r.data);
      }
    })
      .finally(() => {
        el.innerText = currentText;
      });
  });
});
